import {createSlice} from "@reduxjs/toolkit";
import {setUISettlementSearchFilter} from "./actions";
import {SettlementSearchCriteria} from "@ots-frontend/ots-data";

type SettlementUIState = {
  searchFilter?: SettlementSearchCriteria
}

const INITIAL_STATE: Readonly<SettlementUIState> = {};

const settlementUISlice = createSlice({
  name: "ots-ui/settlement",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUISettlementSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const settlementUIReducer = settlementUISlice.reducer;
